class NotifyMe extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", (e) => {
      e.preventDefault();
      this.submitForm(e);
    });

    this.url = this.dataset["endpoint"];
  }

  getDefaultVariantId() {
    this.selectedProduct = document.querySelector("product-hero");
    this.selectedVariantId = JSON.parse(
      this.selectedProduct.dataset["selectedVariantId"]
    );
    return this.selectedVariantId;
  }

  getVariantUrlParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const entries = urlParams.entries();
    const result = {};
    for (const [key, value] of entries) {
      result[key] = value;
    }
    return result.variant;
  }

  async submitForm(e) {
    const email = this.querySelector("[type='email']").value;
    const button = this.querySelector("button");
    const variant = this.getVariantUrlParam()
      ? this.getVariantUrlParam()
      : this.getDefaultVariantId();
    const endpoint = `${this.url}/api/notify-me-subscribe`;
    const body = JSON.stringify({ email, variant });
    const notif = this.querySelector("p");

    button.disabled = "true";
    button.innerHTML = "Subscribing...";

    const res = await fetch(endpoint, { method: "POST", body: body });
    const data = await res.json();

    this.form.style.display = "none";
    notif.innerHTML =
      "Success! You’ll receive an email when this product is back in stock.";
  }
}

customElements.define("notify-me", NotifyMe);
